import { createContext } from "react";
import Application from "../../store/app/types/Application";

export const ApplicationFeaturesContext = createContext<
  Application["features"] | undefined
>(undefined);
